import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";

import { useDispatch } from "react-redux";
import { updateElement } from "../../../store/formSlice";

const CustomTextField = (props) => {
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const updatedValue = event.target.value; // Get the new value from the event

    // Update the element in the form state
    const updatedElement = {
      id: props.elementId,
      element: {
        ...props,
        value: updatedValue,
      },
    };
    dispatch(updateElement(updatedElement));
  };

  return (
    <TextField
      label={props.label}
      placeholder={props.label}
      value={props.value}
      onChange={handleChange} // Pass handleChange as the onChange handler
      fullWidth
      color={props.color}
      required={props.required}
      error={props.error}
      helperText={props.helperText}
      InputProps={{
        sx: {
          height: {
            xs: "auto",
            sm: "auto",
            md: "auto",
            lg: props.height,
            xl: props.height,
          },
          alignItems: "center",
          paddingRight: "10px",
        },
      }}
      InputLabelProps={{
        shrink: true,
        sx: {
          transform: "translate(14px, -9px) scale(0.75)",
        },
      }}
      sx={{
        width: {
          xs: props.width, // Full width on extra-small screens
          sm: props.width, // 75% width on small screens
          md: props.width, // 50% width on medium screens
          lg: props.width, // Use provided width on large screens
          xl: props.width, // Use provided width on extra-large screens
        },
        // height: {
        //   xs: "auto", // Auto height on extra-small screens
        //   sm: "auto", // Auto height on small screens
        //   md: "auto", // Auto height on medium screens
        //   lg: props.height, // Use provided height on large screens
        //   xl: props.height, // Use provided height on extra-large screens
        // },
        marginLeft: props.marginLeft,
        marginTop: props.marginTop,
      }}
      size={props.size || "small"}
    />
  );
};

CustomTextField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CustomTextField;
